export enum ListItemEvents {
  EXTERNAL_LINK_CLICK = 'list.item.external_link.click',
}
